import React, { ChangeEvent } from 'react';
import { Components } from './styled';

const ProjectTextArea = ({
  value,
  onChangeText,
  onBlur,
  rows = 4,
  placeholder,
  disabled = false,
  isFullHeight = false,
  name,
  errorMessage,
}: {
  value?: string;
  onChangeText?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: () => void;
  fontSize?: 'default' | 'big' | 'veryBig';
  rows?: number;
  placeholder?: string;
  disabled?: boolean;
  isFullHeight?: boolean;
  name?: string;
  errorMessage?: string;
}) => {
  const _onChangeText = (e: ChangeEvent<HTMLTextAreaElement>): void => {
    onChangeText?.(e);
  };

  const _onBlur = () => {
    onBlur?.();
  };

  return (
    <Components.Container isFullHeight={isFullHeight}>
      <Components.TextAreaContainer>
        <Components.TextArea
          value={value}
          rows={rows}
          placeholder={placeholder}
          onChange={_onChangeText}
          onBlur={_onBlur}
          disabled={disabled}
          {...(name && { name })}
        />
      </Components.TextAreaContainer>
      {errorMessage && <Components.ErrorMessage>{errorMessage}</Components.ErrorMessage>}
    </Components.Container>
  );
};

export default ProjectTextArea;
